import { useContext, useMemo } from "react"
import { DataContext } from "contexts/DataContext"
import { contentUsage } from "lib/playlist"

// Where the content is played: [usage, refresh]. `usage` is a Map(contentId -> [{ id, name, count }]),
// the regular broadcasts that hold it (see lib/playlist.js). It comes straight from the shared
// broadcast list of DataContext, so it keeps the same reference until that list is loaded again
// (a page can pass it to a table without making the table start over on every redraw).
export const useContentUsage = () => {
  const { broadcasts } = useContext(DataContext)
  const [broadcastItems, , , refreshBroadcasts] = broadcasts

  const usage = useMemo(() => contentUsage(broadcastItems), [broadcastItems])
  return [usage, refreshBroadcasts]
}
